export function CollapseOpen() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 17 16"
    >
      <g fill="#000" fillOpacity="0.88" fillRule="evenodd" clipRule="evenodd">
        <path d="M11.687 9.647L10.04 8l1.647-1.647a.5.5 0 10-.707-.706l-2 2a.5.5 0 000 .706l2 2a.5.5 0 00.707-.706z"></path>
        <path d="M14 1.333A1.167 1.167 0 0115.167 2.5v11c0 .644-.523 1.167-1.167 1.167H3A1.167 1.167 0 011.833 13.5v-11A1.167 1.167 0 013 1.333h11zm.167 1.167A.167.167 0 0014 2.333H6.5v11.334H14a.167.167 0 00.167-.167v-11zM5.5 13.667V2.333H3a.167.167 0 00-.167.167v11a.167.167 0 00.167.167h2.5z"></path>
      </g>
    </svg>
  );
}
